import { render, staticRenderFns } from "./teacher_detail.vue?vue&type=template&id=ed15e144&"
import script from "./teacher_detail.vue?vue&type=script&lang=js&"
export * from "./teacher_detail.vue?vue&type=script&lang=js&"
import style0 from "./teacher_detail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports